import React from 'react'
import { Row, Col, Form, Select } from 'antd';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
  },
};

const CalculatedCrisis = ({volume, price, form, loadingFreq, freq }) => {
  const { getFieldDecorator } = form;
  return <Row>
    <Col span={8}>
      <Form.Item label="Frequency" {...formItemLayout}>
        {getFieldDecorator('data_freq', {
          initialValue: ['Monthly'],
        })(<Select style={{ width: '100%' }} loading={loadingFreq} placeholder='Vui lòng chọn Frequency'>
          {freq.map(item => <Option key={item.key} value={item.name}>{item.name}</Option>)}
        </Select>)}
      </Form.Item>
    </Col>
    <Col span={8}>
      Volume: <span className='gx-text-primary'>{volume || 0}</span>
    </Col>
    <Col span={8}>
      Price: <span className='gx-text-primary'>{price ? Math.ceil(price).toLocaleString('us') : 0} đ</span>
    </Col>
  </Row>
}

export default Form.create({
  name: 'form_input_crisis',
  onValuesChange: (props, changedValues) => {
    const { onChangeFields } = props;
    if (changedValues.data_freq) {
      onChangeFields(changedValues);
    }
  },
})(CalculatedCrisis);
